const isIOS = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as Window & {
    MSStream?: unknown;
  }).MSStream;
};
export default isIOS;